'use strict';
define([
    'angular',
    'modules/project/project.routes',
    'modules/project/workspace/workspace.controller',
    'modules/project/workspace/section.controller',
    'modules/project/settings/tracker/tracker.component',
    'modules/project/components/step-navbar/step-navbar.component',
    'modules/project/components/chart-keywords/chart-keywords.component',
    'modules/project/wizard/steps/create-project/create-project.component',
    'modules/project/wizard/steps/add-keywords/add-keywords.component',
    'modules/project/wizard/steps/add-locations/add-locations.component',
    'modules/project/wizard/steps/set-locations/set-locations.component',
    'modules/project/wizard/steps/choose-competitors/choose-competitors.component',
    'modules/project/wizard/steps/schedule-audits/schedule-audits.component',
    'modules/project/components/crawl-session/crawl-session.component',
    'modules/project/components/aeo-checker/aeo-checker.component',
    'modules/project/components/traffic-insights/traffic-insights.component',
    'modules/project/components/issue-row/issue-row.component',
    'modules/project/components/st-score-gauge/st-score-gauge.component',
    'modules/project/settings/settings.module',
    'modules/project/dialogs/dialogs.module',
    'modules/project/wizard/wizard.module',

], function (
    angular,
    routes,
    ProjectWorkspaceController,
    ProjectWorkspaceSectionController,
    Tracker,
    stepNavbar,
    chartKeywords,
    createProject,
    addKeywords,
    addLocations,
    setLocations,
    chooseCompetitors,
    scheduleAudits,
    crawlSession,
    aeoChecker,
    trafficInsights,
    issueRow,
    scoreGauge
    ) {
    var app = angular.module('app.project', [
        'app.project.settings',
        'app.project.dialogs',
        'app.project.wizard',
    ]);

    app.config(routes);
    app.controller('ProjectWorkspaceCtrl', ProjectWorkspaceController);
    app.controller('ProjectWorkspaceSectionCtrl', ProjectWorkspaceSectionController);
    app.component('tracker', Tracker);
    app.component('stepNavbar', stepNavbar);
    app.component('chartKeywords', chartKeywords);
    app.component('createProject', createProject);
    app.component('addKeywords', addKeywords);
    app.component('addLocations', addLocations);
    app.component('setLocations', setLocations);
    app.component('chooseCompetitors', chooseCompetitors);
    app.component('scheduleAudits', scheduleAudits);
    app.component('stCrawlSession', crawlSession);
    app.component('stAeoChecker', aeoChecker);
    app.component('stProjectTraffic', trafficInsights);
    app.component('stProjectIssue', issueRow);
    app.component('stScoreGauge', scoreGauge);
    app.directive('stCsvDrop', function () {
        return {
            restrict: 'A',
            scope: {
                onFile: '&stCsvDrop'
            },
            link: function (scope, element) {
                var node = element[0];
                var input = node.querySelector('input[type="file"]');

                function deliver(file) {
                    if (!file) {
                        return;
                    }
                    scope.$evalAsync(function () {
                        scope.onFile({file: file});
                    });
                }

                function onDragEnter(event) {
                    event.preventDefault();
                    element.addClass('is-dragging');
                }

                function onDragOver(event) {
                    event.preventDefault();
                    if (event.dataTransfer) {
                        event.dataTransfer.dropEffect = 'copy';
                    }
                }

                function onDragLeave(event) {
                    if (!node.contains(event.relatedTarget)) {
                        element.removeClass('is-dragging');
                    }
                }

                function onDrop(event) {
                    event.preventDefault();
                    element.removeClass('is-dragging');
                    deliver(event.dataTransfer && event.dataTransfer.files
                        ? event.dataTransfer.files[0] : null);
                }

                function onInputChange() {
                    deliver(input && input.files ? input.files[0] : null);
                    if (input) {
                        input.value = '';
                    }
                }

                element.on('dragenter', onDragEnter);
                element.on('dragover', onDragOver);
                element.on('dragleave', onDragLeave);
                element.on('drop', onDrop);
                if (input) {
                    input.addEventListener('change', onInputChange);
                }

                scope.$on('$destroy', function () {
                    element.off('dragenter', onDragEnter);
                    element.off('dragover', onDragOver);
                    element.off('dragleave', onDragLeave);
                    element.off('drop', onDrop);
                    if (input) {
                        input.removeEventListener('change', onInputChange);
                    }
                });
            }
        };
    });
    return app;
});
